import { Divider, useMantineTheme } from '@mantine/core'

import { OnboardingRoutePathsEnum } from '@/modules/onboarding/routes/onboardingRouteConfig.types'
import { ChangePasswordForm } from '@/modules/profile/components/ChangePasswordForm/ChangePasswordForm'
import { Main } from '@/modules/profile/components/Main/Main'

import { useUserStore } from '@/store/user.store'

import { InlineLink } from '@/components/InlineLink/InlineLink'
import { Text } from '@/components/Text/Text'

import { role } from '@/__generated__/requests'

export function Component() {
  const theme = useMantineTheme()

  const user = useUserStore.use.user()

  return (
    <Main header="Settings">
      {user?.roles?.includes(role.EMPLOYEE) && (
        <>
          <Text mb={10}>Onboarding</Text>

          <Text mb={24} variant="body_2">
            To receive the best recommendations from planners, we recommend
            completing the onboarding form and keeping your data up to date.
          </Text>

          <InlineLink
            label="Edit answers"
            target={OnboardingRoutePathsEnum.ONBOARDING_EDIT}
          />

          <Divider color={theme.other.colors.lightGrey} mb={40} mt={32} />
        </>
      )}

      <Text>Password</Text>

      <ChangePasswordForm />
    </Main>
  )
}

Component.displayName = 'Settings'
